module.exports = __webpack_public_path__ + "img/video-create.9e077af6.svg";